document.addEventListener('DOMContentLoaded', function () {
  // All filter pills on the page
  var pills = document.querySelectorAll('.jansen-filter-pill');
  if (!pills.length) return;

  // Hidden "real" filter trigger that opens the drawer
  var drawerTrigger = document.querySelector('.jansen-filter-hidden-trigger.js-drawer-open-collection-filters');
  if (!drawerTrigger) return;

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var target = pill.getAttribute('data-filter-target') || 'all';

      // Open the drawer using the theme's JS
      drawerTrigger.click();

      if (target === 'all') {
        // More Filters: just open the drawer
        return;
      }

      // Wait a bit so the drawer is visible before jumping
      setTimeout(function () {
        // Drawer groups are the collapsible-content elements
        var group = document.querySelector('[data-collapsible-id="' + target + '"]');
        if (!group) return;

        // Expand group if needed
        var trigger = document.querySelector(
          '.collapsible-trigger[data-collapsible-id="' + target + '"]'
        );
        if (trigger && trigger.getAttribute('aria-expanded') === 'false') {
          trigger.click();
        }

        // Scroll the group into view inside the drawer
        group.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    });
  });
});
